import DailyCounter from './DailyCounter'

const DailyButcher = () => (
    <DailyCounter counterType='butcher'/>
)

export default DailyButcher
